import React from "react";

export const LOGO_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_care-platform-61/artifacts/cvqnmhzg_WeCare2_2.webp";

export default function BrandLogo({ className = "h-9", light = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="WeCare II"
      className={`${className} w-auto object-contain ${light ? "brightness-0 invert" : ""}`}
      data-testid="brand-logo-img"
    />
  );
}
